import {PuiDateField} from "@portnet/ui";
import React from "react";

const AppDateField = React.forwardRef((props, ref) => {
  return <PuiDateField ref={ref} {...props} />;
});

export default AppDateField;
